import { db } from '../utils/firebase';

export const getAllOutreaches = async () => {
  const querySnapshot = await db.collection("outreach").get();
  const data = [];
  querySnapshot.forEach(doc => {
    const { title, content, order } = doc.data();
    data.push({ title, order, content: (content || []).reverse() });
  });

  // sort each section
  data.sort((a, b) => a.order - b.order);

  return data;
};

export const getDescriptionById = async (id, url) => {
  const querySnapshot = await db.collection(url).where("id", "==", id).get();

  const result = { title: '', content: '', images: [] };

  if (querySnapshot.docs.length === 1) {
    querySnapshot.forEach(doc => {
      const { title, content, images } = doc.data();

      result.title = title ? title : '';
      result.content = content ? content : '';
      result.images = images;
    });
  }

  return result;
}